/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DropdownNoRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import DropdownButtonArrow from 'DesignSystem/DropdownButtonArrow/index'
import DropdownOptions from 'DesignSystem/DropdownOptions/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function DropdownNoRepeater({
  children,
  viewPath = "/DesignSystem/DropdownNoRepeater",
  marginLeft = 0,
  dropdownRef,
  toggleIsShowing,
  selected,
  isSelected,
  isShowing,
  field = "text",
  from,
  onClick,
  height = 125,
  width
  
}) {
  return (<React.Fragment
>
<div
  data-testid="DropdownNoRepeater.Vertical"
  data-view-path={viewPath}
 style={{'--ml-1-qp8sL': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DropdownNoRepeater.Vertical:1"
  data-view-path={viewPath}
 ref={dropdownRef}
 className="views-block"
>
<DropdownButtonArrow
  viewPath={`${viewPath}/DropdownButtonArrow`}
 text="Change"
 onClick={toggleIsShowing}
 selected={selected}
 isSelected={isSelected}
/>
<fromFlow.When is={isShowing}>
<DropdownOptions
  viewPath={`${viewPath}/DropdownOptions`}
 field={field}
 from={from}
 onClick={onClick}
 selected={selected}
 isSelected={isSelected}
 height={height}
 width={width}
 top={26}
/>
</fromFlow.When>
</div>
</div>
{children}
</React.Fragment>)
}